import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';

export function* getOrCreateDampingCoefficientInCurrentBoard() {
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
  if (!pointSystem) {
    return;
  }

  yield put(actions.getOrCreateDampingCoefficient(pointSystem.id));

  let item;
  try {
    ({ item } = yield call(request, api.getOrCreateDampingCoefficient, pointSystem.id));
  } catch (error) {
    yield put(actions.getOrCreateDampingCoefficient.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.getOrCreateDampingCoefficient.success(item));
}

export function* fetchDampingCoefficientsInCurrentBoard() {
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
  if (!pointSystem) {
    return;
  }

  yield put(actions.fetchDampingCoefficients(pointSystem.id));

  let items;
  try {
    ({ items } = yield call(request, api.fetchDampingCoefficients, pointSystem.id));
  } catch (error) {
    yield put(actions.fetchDampingCoefficients.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.fetchDampingCoefficients.success(pointSystem.id, items));
}

export function* createDampingCoefficient(pointSystemId, data = {}) {
  yield put(actions.createDampingCoefficient(pointSystemId));

  let item;
  try {
    ({ item } = yield call(request, api.createDampingCoefficient, pointSystemId, data));
  } catch (error) {
    yield put(actions.createDampingCoefficient.failure(pointSystemId, error));
    return;
  }

  yield put(actions.createDampingCoefficient.success(item));
}

export function* updateDampingCoefficient(id, data) {
  yield put(actions.updateDampingCoefficient(id, data));

  let item;
  try {
    ({ item } = yield call(request, api.updateDampingCoefficient, id, data));
  } catch (error) {
    yield put(actions.updateDampingCoefficient.failure(id, error));
    return;
  }

  yield put(actions.updateDampingCoefficient.success(item));
}

export function* deleteDampingCoefficient(id) {
  yield put(actions.deleteDampingCoefficient(id));

  let item;
  try {
    ({ item } = yield call(request, api.deleteDampingCoefficient, id));
  } catch (error) {
    yield put(actions.deleteDampingCoefficient.failure(id, error));
    return;
  }

  yield put(actions.deleteDampingCoefficient.success(item));
}

export default {
  getOrCreateDampingCoefficientInCurrentBoard,
  fetchDampingCoefficientsInCurrentBoard,
  createDampingCoefficient,
  updateDampingCoefficient,
  deleteDampingCoefficient,
};

